module.exports = __webpack_public_path__ + "static/media/brush_10.135b134d.png";